import {
  useMutation,
  useQuery as useReactQuery,
  useQueryClient,
} from "@tanstack/react-query";
import FetchClients, { ClientOutput } from "../client";

const siteInterviews = {
  useQuery,
  mutations: {
    usePut,
  },
};

export default siteInterviews;

export type SiteInterview = ClientOutput["site"]["SiteInterview"];

const SITE_INTERVIEW_KEY = "site-interview";

async function getSiteInterview(site_id: number) {
  const { data, error } = await FetchClients.site.GET(
    "/{site_id}/site-interview",
    {
      params: { path: { site_id } },
    }
  );
  if (data) return data;
  throw new Error(error);
}

function useQuery(
  siteId: number,
  { enabled = true }: { enabled?: boolean } = {}
) {
  return useReactQuery({
    queryKey: [SITE_INTERVIEW_KEY, siteId],
    queryFn: () => getSiteInterview(siteId),
    enabled,
  });
}

const putSiteInterview = async (
  site_id: number,
  siteInterview: SiteInterview
) => {
  const { response, error } = await FetchClients.site.PUT(
    "/{site_id}/site-interview",
    {
      params: { path: { site_id } },
      body: siteInterview,
    }
  );
  if (response.ok) return;
  throw new Error(error);
};

function usePut(siteId: number) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (siteInterview: SiteInterview) =>
      putSiteInterview(siteId, siteInterview),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [SITE_INTERVIEW_KEY, siteId],
      });
    },
  });
}
